import { render, staticRenderFns } from "./SafeEmailAdd.vue?vue&type=template&id=35cc161d&scoped=true&"
import script from "./SafeEmailAdd.vue?vue&type=script&lang=js&"
export * from "./SafeEmailAdd.vue?vue&type=script&lang=js&"
import style0 from "./SafeEmailAdd.vue?vue&type=style&index=0&id=35cc161d&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "35cc161d",
  null
  
)

export default component.exports